<template>
  <BCardBody v-if="isMobile">
    <div class="image-container">
      <a :href="`${baseURL}/portfolio-review-pro`" target="_blank">
        <img :src="mainMobImage" alt="Main Image" class="main-image" />
        <swiper
          :autoplay="autoplay"
          :loop="true"
          direction="horizontal"
          class="custom-swiper"
        >
          <swiper-slide v-for="(overlay, index) in overlaysMob" :key="index">
            <img :src="overlay.src" :alt="overlay.alt" class="carousel-image" />
          </swiper-slide>
        </swiper>
      </a>
    </div>
  </BCardBody>
  <BCardBody class="backgroundSection" v-else>
    <a
      :href="`${baseURL}/portfolio-review-pro`"
      target="_blank"
      class="link-wrapper"
    >
      <div class="image-container">
        <swiper
          :autoplay="autoplay"
          :loop="true"
          direction="vertical"
          class="custom-swiper"
        >
          <swiper-slide v-for="(overlay, index) in overlays" :key="index">
            <img :src="overlay.src" :alt="overlay.alt" class="carousel-image" />
          </swiper-slide>
        </swiper>
      </div>
    </a>
  </BCardBody>
</template>

<script>
import { Swiper as SwiperClass, Autoplay } from "swiper/core";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
import step1 from "@/assets/images/portfolio/step1Web.svg";
import step2 from "@/assets/images/portfolio/step2Web.svg";
import step3 from "@/assets/images/portfolio/step3Web.svg";
import step1Mob from "@/assets/images/portfolio/step1Mob.svg";
import step2Mob from "@/assets/images/portfolio/step2Mob.svg";
import step3Mob from "@/assets/images/portfolio/step3Mob.svg";
SwiperClass.use([Autoplay]);
export default {
  name: "PrpExpired",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
      isMobile: window.innerWidth <= 768,
      mainImage: require("@/assets/images/portfolio/main.svg"),
      mainMobImage: require("@/assets/images/portfolio/trialMobBase.svg"),
      baseURL: process.env.VUE_APP_BASE_URL,
      overlays: [
        { src: step1, alt: "step1" },
        { src: step2, alt: "step2" },
        { src: step3, alt: "step3" },
      ],
      overlaysMob: [
        { src: step1Mob, alt: "step1" },
        { src: step2Mob, alt: "step2" },
        { src: step3Mob, alt: "step3" },
      ],
    };
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= 768;
    },
  },
};
</script>

<style scoped>
.image-container {
  position: relative;
  width: 100%;
  border-radius: 10px;
}

.main-image {
  width: 100%;
  border-radius: 10px;
}

.custom-swiper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.carousel-image {
  width: 100%;
  height: auto;
}

.backgroundSection {
  background-image: url("@/assets/images/portfolio/trialWeb.svg");
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 0.375rem;
  margin: 2px;
  position: relative;
}

.link-wrapper {
  display: block;
  height: 100%;
  width: 100%;
  text-decoration: none;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
</style>
